<template>
  <div
    class="absolute top-0 h-full w-72 pt-16 transition bg-white"
    :class="{'-x-100': !sideBar }"
  >
    <div class="h-full overflow-y-auto scrollbar-style">
      <RouterLink
        v-show="$route.meta.sidebarInner"
        to="/explore"
        class="block h-14 bg-secondary px-6 flex items-center text-white"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32" v-bind:svg-inline="''" v-bind:class="'h-4 w-4 fill-current rotate-90 mr-2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 0h56.004L27.896 32z"/></svg>
        <span>Back to all</span>
      </RouterLink>

      <h1
        class="h-16 bg-primary text-white px-6 flex items-center"
        v-html="$route.meta.sidebarInner ? `Explore ${category.title}` : 'Explore the campus'"
      />

      <!-- Outer sidebar content -->
      <div
        v-for="(category, i) in categories"
        v-show="$route.meta.sidebarOuter"
        :key="category.category"
      >
        <button
          class="h-14 px-4 w-full flex items-center justify-between text-left text-primary border-l-6 focus:border-primary focus:outline-none"
          :class="[ outerTabIndex === i ? 'border-primary font-bold' : 'border-transparent', { 'hover:border-primary': !touch } ]"
          @click="outerTabIndex = outerTabIndex === i ? false : i"
        >
          {{ category.title }}

          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32" v-bind:svg-inline="''" v-bind:class="'h-3 w-3 fill-current'" :class="{ 'rotate-180': outerTabIndex === i }" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 0h56.004L27.896 32z"/></svg>
        </button>

        <poseWrapper
          class="bg-grey-300 overflow-hidden"
          :pose="outerTabIndex === i ? 'open' : 'closed'"
          :with-parent="false"
        >
          <RouterLink
            v-for="item in category.tours"
            :key="item.slug"
            :to="`${item.slug}/${item.children[0].slug}`"
            append
            class="block pl-10 pr-3 h-12 text-sm flex items-center"
            :class="{ 'hover:bg-primary hover:text-white': !touch }"
            v-html="item.title"
          />
        </poseWrapper>
      </div>

      <!-- Inner sidebar content -->
      <div v-if="$route.meta.sidebarInner">
        <div
          v-for="(item, i) in category.children"
          :key="item.slug"
        >
          <RouterLink
            :to="item.slug"
            class="h-14 px-4 w-full flex items-center justify-between text-left text-primary border-l-6 focus:border-primary focus:outline-none"
            :class="[ item.slug === slug ? 'border-primary font-bold' : 'border-transparent', { 'hover:border-primary': !touch } ]"
            @click.native="innerTabIndex = i"
          >
            {{ item.title }}

            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32" v-bind:svg-inline="''" v-bind:class="'h-3 w-3 fill-current'" :class="[ innerTabIndex === i && item.slug === slug ? 'rotate-0' : 'rotate-270' ]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 0h56.004L27.896 32z"/></svg>
          </RouterLink>

          <poseWrapper
            class="bg-grey-300 overflow-hidden"
            :pose="innerTabIndex === i && item.slug === slug ? 'open' : 'closed'"
            :with-parent="false"
          >
            <!-- purgecss: border-accent-1 border-accent-2 border-accent-3 text-accent-1 text-accent-2 text-accent-3 -->
            <button
              v-for="(hotspot, index) in category.children[i].children"
              :key="hotspot.slug"
              class="flex items-center justify-between w-full text-left pl-6 pr-3 h-12 text-sm border-l-10"
              :class="`border-${hotspot.color}`"
              @click="$emit('hotspot-click', index), mobile ? sideBar = false : ''"
            >
              <span v-html="hotspot.title" />
              <IconBase
                :icon="`icon${hotspot.type}`"
                :color="hotspot.color"
              />
            </button>
          </poseWrapper>
        </div>
      </div>
    </div>

    <button
      class="absolute pin-c-y right-0 flex-c -m-10 h-10 w-10 bg-white rounded-r-sm"
      @click="sideBar = !sideBar"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" v-bind:svg-inline="''" v-bind:class="'h-4 w-4 text-primary fill-current'" :class="{ 'rotate-45': !sideBar }" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.999 18.908L2.909 32 0 29.09l13.085-13.085L0 2.908 2.909 0l13.085 13.085L29.09 0 32 2.908 18.908 16.005 31.993 29.09 29.09 32z"/></svg>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'
import posed from 'vue-pose'

export default {
  name: 'Sidebar',

  components: {
    IconBase,
    poseWrapper: posed.div({ closed: { height: 0 }, open: { height: 'auto' }})
  },

  data: () => ({
    sideBar: true,
    outerTabIndex: false,
    innerTabIndex: 0
  }),

  computed: {
    ...mapGetters([ 'categories', 'category' ]),
    ...mapState([ 'touch', 'slug', 'mobile' ])
  }
}
</script>
